declare const __GTAG_ID__: string | undefined;
declare const __APP_ENV__: string;

/**
 * Initialize Google Analytics (gtag.js).
 * Enabled in deployed environments when a tag ID is configured.
 */
export function initGtag(): void {
  if (!__GTAG_ID__ || __APP_ENV__ === 'local') {
    return;
  }

  const script = document.createElement('script');
  script.async = true;
  script.src = `https://www.googletagmanager.com/gtag/js?id=${__GTAG_ID__}`;
  document.head.appendChild(script);

  window.dataLayer = window.dataLayer || [];
  function gtag(...args: unknown[]) {
    window.dataLayer.push(args);
  }
  gtag('js', new Date());
  gtag('config', __GTAG_ID__);
}

declare global {
  interface Window {
    dataLayer: unknown[];
  }
}
